import React from 'react';

/**
 * The hero film: 32 seconds, silent, looping, built in code (../../motion).
 * Two cuts of one timeline: 16:9 for wide screens, and a 9:16 portrait cut
 * for phones (headline on top, the device below at 1.4x) - at phone width
 * the wide film's panel text was too small to read. The frame's shape
 * (App.css) and the file follow the same 760px breakpoint. Nothing here
 * blocks first paint: the poster is the film's own first frame (the page's
 * background) and only metadata is preloaded. A visitor who prefers reduced
 * motion gets the end card as a still - the swap is in CSS, so no script
 * runs to decide it.
 */
const PHONE = '(max-width: 760px)';

const HeroFilm = () => (
  <section className="hero-film-section" aria-label="Snapcipe in 32 seconds">
    <div className="hero-film">
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster="/media/snapcipe-hero-poster.jpg"
        aria-label="A film of Snapcipe: a salmon bowl is photographed, the recipe writes itself - ingredients, method, timings, nutrition - then a fridge and a cookbook page are scanned, a video link is imported, and recipes are grouped into collections."
      >
        <source src="/media/snapcipe-hero-portrait.webm" type="video/webm" media={PHONE} />
        <source src="/media/snapcipe-hero-portrait.mp4" type="video/mp4" media={PHONE} />
        <source src="/media/snapcipe-hero-1080p.webm" type="video/webm" />
        <source src="/media/snapcipe-hero-1080p.mp4" type="video/mp4" />
      </video>
      <picture className="hero-film-still">
        <source media={PHONE} srcSet="/media/snapcipe-hero-portrait-endcard.jpg" />
        <img
          src="/media/snapcipe-hero-endcard.jpg"
          alt="Snapcipe AI - your pocket kitchen. Now on the App Store, iOS 17 and later. snapcipe.app"
          loading="lazy"
        />
      </picture>
    </div>
  </section>
);

export default HeroFilm;
